import React from "react";
import {
  AdditionalInformationSection,
  FromButton,
  ImpactText,
  OrganizationForm,
  SocialIcon,
  SubTitle,
  SubTitleNumber,
  SubTitleText,
  TwitterImageIcon,
} from "./EditProfileStyle";
import { Button, Col, Form, Image, Row } from "react-bootstrap";
import FaceBookIcon from "../../../assests/images/facebook.svg";
import TwitterIcon from "../../../assests/images/xicon.svg";
import * as Yup from "yup"
import { useFormik } from "formik";
import { AdditionalInformationFormikProp } from "../../../utils/types";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { editNonprofitProfileHandler } from "../../../redux/slices/myNonprofit/editnonprofit-slice";

const AdditionalInformation = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const editNonprofitProfileSlice: any = useSelector(
    (state: any) => state?.editNonprofitProfile
  );


  const nonprofitProfile: any = useSelector(
    (state: any) => state?.editNonprofitProfile?.data?.results
  );

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      ein: nonprofitProfile?.ein || "",
      aka: nonprofitProfile?.aka || "",
      phone: nonprofitProfile?.phone || "",
      mission: nonprofitProfile?.mission || "",
      results: nonprofitProfile?.results || "",
      facebook_page: nonprofitProfile?.facebook_page || "",
      twitter_account: nonprofitProfile?.twitter_account || "",
    },
    validationSchema: Yup.object({
      facebook_page: Yup.string().trim().url("Please enter valid URL"),
      twitter_account: Yup.string().trim().url("Please enter valid URL"),
    }),
    onSubmit: (values: AdditionalInformationFormikProp) => {
      if (id) {
        dispatch(editNonprofitProfileHandler(id, values) as any);
      }
    },
  });
  return (
    <AdditionalInformationSection>
      <SubTitle>
        <SubTitleNumber>04</SubTitleNumber>
        <SubTitleText>
          Additional Information <ImpactText>(Optional)</ImpactText>
        </SubTitleText>
      </SubTitle>
      <OrganizationForm onSubmit={formik.handleSubmit}>
        <Row>
          <Col sm={12} md={12} lg={6}>
            <Form.Group className="input-box">
              <Form.Label>EIN</Form.Label>
              <Form.Control
                type="number"
                onKeyDown={(evt) =>
                  ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()
                }
                name="ein"
                value={formik.values.ein}
                onChange={(e) => {
                  // Ensure only numbers are entered and limit the input to 9 digits
                  const value = e.target.value;
                  if (value.length <= 9) {
                    formik.setFieldValue('ein', value);
                  }
                }}
                placeholder="20-8882478"
              />

            </Form.Group>
          </Col>
          <Col sm={12} md={12} lg={6}>
            <Form.Group className="input-box">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                type="number"
                onKeyDown={(evt) =>
                  ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()
                }
                name="phone"
                onChange={(e) => {
                  // Ensure only numbers are entered and limit the input to 9 digits
                  const value = e.target.value;
                  if (value.length <= 15) {
                    formik.setFieldValue('phone', value);
                  }
                }}
                value={formik.values.phone}
                placeholder="(231)574-3376"
              />
            </Form.Group>
          </Col>
          <Col sm={12} md={12} lg={6}>
            <Form.Group className="input-box">
              <Form.Label>Mission</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                type="textarea"
                name="mission"
                value={formik.values.mission}
                onChange={formik.handleChange}
                placeholder="Provide transparency"
              />
            </Form.Group>
          </Col>
          <Col sm={12} md={12} lg={6}>
            <Form.Group className="input-box">
              <Form.Label>Results to Date</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                type="textarea"
                name="results"
                value={formik.values.results}
                onChange={formik.handleChange}
              />
            </Form.Group>
          </Col>
          <Col sm={12} md={12} lg={6}>
            <Form.Group className="input-box">
              <Form.Label>Alternative Names</Form.Label>
              <Form.Control
                type="text"
                name="aka"
                value={formik.values.aka}
                onChange={formik.handleChange}
              />
            </Form.Group>
          </Col>
          <Col sm={12} md={12} lg={6}></Col>
          <Col sm={12} md={12} lg={6}>
            <Form.Group className="input-box social-box">
              <SocialIcon>
                <Image src={FaceBookIcon} />
              </SocialIcon>
              <Form.Control
                type="text"
                placeholder="Facebook Page URL"
                name="facebook_page"
                value={formik.values.facebook_page}
                onChange={formik.handleChange}
              />
            </Form.Group>
          </Col>
          <Col sm={12} md={12} lg={6}></Col>
          <Col sm={12} md={12} lg={6}>
            <Form.Group className="input-box social-box">
              <TwitterImageIcon>
                <Image src={TwitterIcon} />
              </TwitterImageIcon>
              <Form.Control
                type="text"
                placeholder="Twitter URL"
                name="twitter_account"
                value={formik.values.twitter_account}
                onChange={formik.handleChange}
              />
            </Form.Group>
          </Col>
          <FromButton>
            <Button className="btn-outline-success-blue" type="submit">
              Save Changes
              {editNonprofitProfileSlice?.isLoading && <span className="btnloader"></span>}
            </Button>
          </FromButton>
        </Row>
      </OrganizationForm>
    </AdditionalInformationSection>
  );
};

export default AdditionalInformation;
